var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuiltWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.42,237.65c.73-32.73-.74-65.09-18-94-27.22-45.73-75.72-75.15-126.67-87.29-40.12-9.55-81.9,1.93-119.36,16.36-17.75,6.84-33.67,16.38-53.05,16.52-21.24.16-41.7-7.76-61.11-15.54C303.38,54.09,246,44.41,193.69,57.31c-26,6.4-51.69,19.62-69.93,40.17-21.3,24-26.8,54.57-33.49,85C81.5,222.24,47.28,252,25.79,285,2,321.45,17.89,370.72,48.53,397.68c103.67,91.21,236.72-28.83,351.1-9.57,59.15,10,115.81,32.51,175.79,37.9,34.78,3.12,72.69,2.52,106.05-10.64,21.4-8.45,42.66-22.45,50.57-45.15,7.17-20.55.44-41.92-1.59-62.73C728.24,284.78,729.89,261.12,730.42,237.65Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.42,237.65c.73-32.73-.74-65.09-18-94-27.22-45.73-75.72-75.15-126.67-87.29-40.12-9.55-81.9,1.93-119.36,16.36-17.75,6.84-33.67,16.38-53.05,16.52-21.24.16-41.7-7.76-61.11-15.54C303.38,54.09,246,44.41,193.69,57.31c-26,6.4-51.69,19.62-69.93,40.17-21.3,24-26.8,54.57-33.49,85C81.5,222.24,47.28,252,25.79,285,2,321.45,17.89,370.72,48.53,397.68c103.67,91.21,236.72-28.83,351.1-9.57,59.15,10,115.81,32.51,175.79,37.9,34.78,3.12,72.69,2.52,106.05-10.64,21.4-8.45,42.66-22.45,50.57-45.15,7.17-20.55.44-41.92-1.59-62.73C728.24,284.78,729.89,261.12,730.42,237.65Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Documents--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "558.12 224.5 514.77 224.5 514.77 175.43 523.48 167.36 558.12 167.36 558.12 224.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.77 175.43 523.56 175.43 523.56 167.36 514.77 175.43",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 181.11,
    x2: 552.46,
    y2: 181.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 186.54,
    x2: 552.46,
    y2: 186.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 191.97,
    x2: 552.46,
    y2: 191.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 197.4,
    x2: 552.46,
    y2: 197.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 202.84,
    x2: 552.46,
    y2: 202.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 208.27,
    x2: 552.46,
    y2: 208.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 520.52,
    y1: 213.7,
    x2: 552.46,
    y2: 213.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.32 217.69 507.97 217.69 507.97 168.63 516.68 160.56 551.32 160.56 551.32 217.69",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.97 168.63 516.76 168.63 516.76 160.56 507.97 168.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 174.31,
    x2: 545.66,
    y2: 174.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 179.74,
    x2: 545.66,
    y2: 179.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 185.17,
    x2: 545.66,
    y2: 185.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 190.6,
    x2: 545.66,
    y2: 190.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 196.04,
    x2: 545.66,
    y2: 196.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 201.47,
    x2: 545.66,
    y2: 201.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 513.72,
    y1: 206.9,
    x2: 545.66,
    y2: 206.9,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "544.51 210.89 501.17 210.89 501.17 161.83 509.88 153.76 544.51 153.76 544.51 210.89",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.17 161.83 509.96 161.83 509.96 153.76 501.17 161.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 167.5,
    x2: 538.86,
    y2: 167.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 172.94,
    x2: 538.86,
    y2: 172.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 178.37,
    x2: 538.86,
    y2: 178.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 183.8,
    x2: 538.86,
    y2: 183.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 189.23,
    x2: 538.86,
    y2: 189.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 194.67,
    x2: 538.86,
    y2: 194.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 506.92,
    y1: 200.1,
    x2: 538.86,
    y2: 200.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.33 156.37 567.99 156.37 567.99 107.31 576.7 99.24 611.33 99.24 611.33 156.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.99 107.31 576.77 107.31 576.77 99.24 567.99 107.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 112.98,
    x2: 605.68,
    y2: 112.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 118.41,
    x2: 605.68,
    y2: 118.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 123.85,
    x2: 605.68,
    y2: 123.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 129.28,
    x2: 605.68,
    y2: 129.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 134.71,
    x2: 605.68,
    y2: 134.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 140.14,
    x2: 605.68,
    y2: 140.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 573.74,
    y1: 145.58,
    x2: 605.68,
    y2: 145.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.96,
    cy: 205.04,
    r: 7.62,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.8,207.54h-.07a1.34,1.34,0,0,1-1-.51l-3.35-4.38a1.32,1.32,0,0,1,2.09-1.6l2.41,3.15,7-7.33a1.32,1.32,0,0,1,1.91,1.81l-8,8.45A1.33,1.33,0,0,1,542.8,207.54Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.34,246.74V245.3a1.8,1.8,0,0,0-1.8-1.8h-23a1.8,1.8,0,0,0-1.8,1.8v1.42a2.55,2.55,0,0,1-2.55,2.54h-.43v52.19H581V251.73a2.48,2.48,0,0,0-2.47-2.47H538.86A2.52,2.52,0,0,1,536.34,246.74Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.16,291a15.7,15.7,0,0,0,0-26",
    style: {
      fill: "none",
      stroke: "#878787",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.29,289.1A15.69,15.69,0,0,0,545.16,291",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.16,265a15.69,15.69,0,0,0-19.87,24.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.91,265.25a1.64,1.64,0,1,0-1.64,1.64A1.63,1.63,0,0,0,560.91,265.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.91,277.68a1.64,1.64,0,1,0-1.64,1.63A1.63,1.63,0,0,0,560.91,277.68Z",
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.91,290.1a1.64,1.64,0,1,0-1.64,1.63A1.63,1.63,0,0,0,560.91,290.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 265.58,
    x2: 572.68,
    y2: 265.58,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 277.35,
    x2: 572.68,
    y2: 277.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 563.53,
    y1: 290.1,
    x2: 572.68,
    y2: 290.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.16,282.89a2.61,2.61,0,0,1-1.46-.35,1.91,1.91,0,0,1-.78-1,4,4,0,0,1-.24-1.45v-.33h1.75v.31a4.26,4.26,0,0,0,.08.73.77.77,0,0,0,.22.44.65.65,0,0,0,.46.15.61.61,0,0,0,.45-.15.94.94,0,0,0,.21-.45,4.91,4.91,0,0,0,0-.73,2.45,2.45,0,0,0-.2-1.08.88.88,0,0,0-.82-.39h-.31v-1.3h.27a1,1,0,0,0,.84-.33,1.87,1.87,0,0,0,.22-1,1.84,1.84,0,0,0-.16-.85.6.6,0,0,0-.59-.31.56.56,0,0,0-.57.34,2.63,2.63,0,0,0-.15.88v.41h-1.75v-.5a2.86,2.86,0,0,1,.3-1.37,1.94,1.94,0,0,1,.84-.86,2.72,2.72,0,0,1,1.33-.3,3,3,0,0,1,1.35.29,1.87,1.87,0,0,1,.84.83,2.75,2.75,0,0,1,.29,1.35,2.55,2.55,0,0,1-.33,1.35,1.54,1.54,0,0,1-.83.68,1.57,1.57,0,0,1,.61.38,1.75,1.75,0,0,1,.41.7,3.37,3.37,0,0,1,.14,1.08,4.47,4.47,0,0,1-.23,1.48,2.09,2.09,0,0,1-.79,1A2.59,2.59,0,0,1,529.16,282.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.11,282.89a2.52,2.52,0,0,1-1.38-.34,2.14,2.14,0,0,1-.82-.94,3.33,3.33,0,0,1-.27-1.38v-4.14a3.49,3.49,0,0,1,.26-1.42,2,2,0,0,1,.81-.95,2.66,2.66,0,0,1,1.4-.34,2.61,2.61,0,0,1,1.38.34,2.07,2.07,0,0,1,.8.95,3.49,3.49,0,0,1,.27,1.42v4.14a3.33,3.33,0,0,1-.28,1.38,2.08,2.08,0,0,1-.82.94A2.46,2.46,0,0,1,535.11,282.89Zm0-1.55a.5.5,0,0,0,.44-.19,1.11,1.11,0,0,0,.18-.46,3.13,3.13,0,0,0,0-.5v-4.06a3.23,3.23,0,0,0,0-.53,1.15,1.15,0,0,0-.18-.47.51.51,0,0,0-.45-.2.53.53,0,0,0-.46.2,1,1,0,0,0-.19.47,4.91,4.91,0,0,0,0,.53v4.06a3.13,3.13,0,0,0,.05.5,1,1,0,0,0,.19.46A.53.53,0,0,0,535.11,281.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.76,278.68a1.9,1.9,0,0,1-1.6-.61,2.8,2.8,0,0,1-.48-1.78v-.47a2.74,2.74,0,0,1,.47-1.77,2,2,0,0,1,1.61-.57,2,2,0,0,1,1.61.56,2.6,2.6,0,0,1,.47,1.74v.54a2.84,2.84,0,0,1-.47,1.76A1.94,1.94,0,0,1,540.76,278.68Zm0-1.13a.53.53,0,0,0,.43-.16.84.84,0,0,0,.17-.46,6.73,6.73,0,0,0,0-.69v-.4a3.57,3.57,0,0,0-.08-.91c-.06-.2-.24-.31-.55-.31s-.49.1-.55.3a3.52,3.52,0,0,0-.09.92v.41a4.58,4.58,0,0,0,0,.69.84.84,0,0,0,.18.45A.51.51,0,0,0,540.76,277.55Zm1.11,5.18,2.77-9.22h1l-2.77,9.22Zm4.92,0a1.93,1.93,0,0,1-1.6-.6,2.86,2.86,0,0,1-.47-1.78v-.47a2.78,2.78,0,0,1,.46-1.77,2,2,0,0,1,1.61-.57,2.05,2.05,0,0,1,1.62.55,2.69,2.69,0,0,1,.47,1.75v.53a2.75,2.75,0,0,1-.48,1.77A2,2,0,0,1,546.79,282.75Zm0-1.12a.55.55,0,0,0,.43-.16.92.92,0,0,0,.17-.45,4.61,4.61,0,0,0,0-.68v-.42a3.47,3.47,0,0,0-.09-.92c-.06-.2-.24-.3-.55-.3s-.48.1-.54.31a3,3,0,0,0-.1.91v.42a6.56,6.56,0,0,0,0,.68.77.77,0,0,0,.18.45A.54.54,0,0,0,546.79,281.63Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.73,238.13v-1.67a2.09,2.09,0,0,0-2.09-2.08H392a2.08,2.08,0,0,0-2.08,2.08v1.64a3,3,0,0,1-2.95,3h-.51v60.4h85.94V243.9a2.84,2.84,0,0,0-2.85-2.85H423.64A2.91,2.91,0,0,1,420.73,238.13Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.97,
    y: 282.57,
    width: 4.73,
    height: 11.82,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.53,
    y: 279.42,
    width: 4.73,
    height: 14.97,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.1,
    y: 282.83,
    width: 4.73,
    height: 11.56,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.67,
    y: 284.93,
    width: 4.73,
    height: 9.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.23,
    y: 268.91,
    width: 4.73,
    height: 25.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.8,
    y: 279.68,
    width: 4.73,
    height: 14.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.36,
    y: 275.74,
    width: 4.73,
    height: 18.65,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.93,
    y: 280.73,
    width: 4.73,
    height: 13.66,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.5,
    y: 283.88,
    width: 4.73,
    height: 10.51,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450.06,
    y: 268.12,
    width: 4.73,
    height: 26.26,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.63,
    y: 264.97,
    width: 4.73,
    height: 29.42,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.19,
    y: 258.14,
    width: 4.73,
    height: 36.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.81 272.06 400.16 264.19 406.46 271.28 412.77 273.11 419.6 257.88 426.16 267.6 432.46 264.71 438.51 270.23 445.6 273.64 452.16 257.36 458.99 255.25 466.08 247.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.59,
    y1: 246.96,
    x2: 404.25,
    y2: 246.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 392.59,
    y1: 250.21,
    x2: 421.32,
    y2: 250.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--folder-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.4,246.74V245.3a1.8,1.8,0,0,0-1.8-1.8h-23a1.81,1.81,0,0,0-1.8,1.8v1.42a2.55,2.55,0,0,1-2.55,2.54h-.43v52.19H353V251.73a2.48,2.48,0,0,0-2.47-2.47H310.92A2.52,2.52,0,0,1,308.4,246.74Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.25,
    y1: 261.98,
    x2: 315.34,
    y2: 261.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.92,
    y1: 261.98,
    x2: 309.95,
    y2: 261.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 261.98,
    x2: 296.82,
    y2: 261.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 303.79,
    y1: 264.6,
    x2: 315.34,
    y2: 264.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 264.6,
    x2: 302.17,
    y2: 264.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.09,
    y1: 267.21,
    x2: 315.34,
    y2: 267.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.38,
    y1: 267.21,
    x2: 309.14,
    y2: 267.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 267.21,
    x2: 292.6,
    y2: 267.21,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.71,
    y1: 269.83,
    x2: 315.34,
    y2: 269.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 269.83,
    x2: 304.76,
    y2: 269.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.55,
    y1: 272.44,
    x2: 315.34,
    y2: 272.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 272.44,
    x2: 292.6,
    y2: 272.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.14,
    y1: 275.06,
    x2: 315.34,
    y2: 275.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 275.06,
    x2: 306.87,
    y2: 275.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 312.71,
    y1: 277.68,
    x2: 315.34,
    y2: 277.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.44,
    y1: 277.68,
    x2: 311.09,
    y2: 277.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 277.68,
    x2: 296.33,
    y2: 277.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "292.76 288.72 292.76 290.83 310.76 290.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "301.19 284.34 299.9 284.34 299.9 296.67 301.19 296.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.22,
    y: 282.88,
    width: 9.89,
    height: 5.91,
    rx: 1.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.19,
    y: 282.88,
    width: 6.32,
    height: 3.73,
    rx: 1.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.19,
    y: 288.88,
    width: 6.32,
    height: 3.73,
    rx: 1.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.3,
    y: 288.88,
    width: 6.32,
    height: 3.73,
    rx: 1.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.19,
    y: 294.88,
    width: 6.32,
    height: 3.73,
    rx: 1.69,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.82,
    y: 266.81,
    width: 2.95,
    height: 10.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.81,
    y: 261.36,
    width: 2.95,
    height: 15.88,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 257.74,
    width: 2.95,
    height: 19.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.78,
    y: 266.81,
    width: 2.95,
    height: 10.43,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 268.85,
    width: 2.95,
    height: 8.39,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.76,
    y: 262.5,
    width: 2.95,
    height: 14.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,288.72v-.63a1.3,1.3,0,0,1-1-.44,2,2,0,0,1-.37-1.25l.95-.16a2.75,2.75,0,0,0,.07.56.73.73,0,0,0,.17.34.44.44,0,0,0,.3.11.29.29,0,0,0,.28-.13.57.57,0,0,0,.08-.32,1,1,0,0,0-.16-.57,2.29,2.29,0,0,0-.43-.47l-.58-.49c-.13-.13-.24-.25-.35-.38a1.49,1.49,0,0,1-.24-.43,1.62,1.62,0,0,1-.09-.57,1.34,1.34,0,0,1,.36-1,1.46,1.46,0,0,1,1-.4v-.6h.33v.6a1.33,1.33,0,0,1,.6.16,1,1,0,0,1,.35.37,1.83,1.83,0,0,1,.18.48,4.53,4.53,0,0,1,.06.5l-1,.14c0-.16,0-.31,0-.44a.7.7,0,0,0-.12-.3.3.3,0,0,0-.27-.1.32.32,0,0,0-.29.15.5.5,0,0,0-.1.31.76.76,0,0,0,.15.5,2.92,2.92,0,0,0,.34.37l.56.48a5.62,5.62,0,0,1,.41.44,1.73,1.73,0,0,1,.3.53,1.67,1.67,0,0,1,.12.65,1.38,1.38,0,0,1-.15.65,1.08,1.08,0,0,1-.42.48,1.43,1.43,0,0,1-.64.22v.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.93,288v-.74l1.33-2c.09-.16.19-.3.28-.44a2.84,2.84,0,0,0,.21-.43,1.23,1.23,0,0,0,.09-.47.64.64,0,0,0-.11-.4.33.33,0,0,0-.29-.14.45.45,0,0,0-.31.11.56.56,0,0,0-.14.29,1.75,1.75,0,0,0,0,.4v.26h-1v-.27a2.31,2.31,0,0,1,.15-.86,1.24,1.24,0,0,1,.48-.6,1.56,1.56,0,0,1,.86-.21,1.31,1.31,0,0,1,1.45,1.44,1.74,1.74,0,0,1-.1.61,2.73,2.73,0,0,1-.27.54l-.35.54-1.06,1.58h1.63V288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.51,289l-.08-.35a.73.73,0,0,0,.32-.18.54.54,0,0,0,.14-.4h-.54v-1h1v.87a1.16,1.16,0,0,1-.21.74A.86.86,0,0,1,326.51,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.45,288v-1.28h-1.66v-.82l1.42-3.37h1.21V286H331v.8h-.53V288Zm-.84-2.08h.84v-2.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.81,288.11a1.48,1.48,0,0,1-.86-.22,1.13,1.13,0,0,1-.46-.59,2.66,2.66,0,0,1-.14-.88,1.87,1.87,0,0,1,0-.42,1.9,1.9,0,0,1,.12-.36,1.1,1.1,0,0,1,.2-.28.83.83,0,0,1,.28-.21,1.44,1.44,0,0,1-.39-.45,1.54,1.54,0,0,1-.17-.75,1.73,1.73,0,0,1,.15-.78,1.07,1.07,0,0,1,.46-.5,1.76,1.76,0,0,1,1.55,0,1,1,0,0,1,.45.5,1.73,1.73,0,0,1,.14.78,1.61,1.61,0,0,1-.16.75,1.25,1.25,0,0,1-.39.45.83.83,0,0,1,.28.21,1.1,1.1,0,0,1,.2.28,1.9,1.9,0,0,1,.12.36,1.86,1.86,0,0,1,0,.42,2.43,2.43,0,0,1-.13.88,1.26,1.26,0,0,1-.47.59A1.47,1.47,0,0,1,332.81,288.11Zm0-.78a.32.32,0,0,0,.29-.13.7.7,0,0,0,.13-.33c0-.13,0-.26,0-.38a1.91,1.91,0,0,0,0-.42.62.62,0,0,0-.13-.33.32.32,0,0,0-.29-.13.32.32,0,0,0-.28.13.62.62,0,0,0-.13.33,2.77,2.77,0,0,0,0,.42,2.53,2.53,0,0,0,0,.38.6.6,0,0,0,.12.33A.34.34,0,0,0,332.81,287.33Zm0-2.57a.26.26,0,0,0,.22-.1.71.71,0,0,0,.13-.29,2.89,2.89,0,0,0,0-.45,1.06,1.06,0,0,0-.09-.47.3.3,0,0,0-.3-.17.32.32,0,0,0-.3.17,1.06,1.06,0,0,0-.09.47,3,3,0,0,0,0,.45.71.71,0,0,0,.13.29A.29.29,0,0,0,332.81,284.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.3,288.1a1.69,1.69,0,0,1-.81-.16.88.88,0,0,1-.44-.47,2,2,0,0,1-.14-.77v-.08h1a1.41,1.41,0,0,0,.07.52c0,.11.16.16.33.16a.3.3,0,0,0,.25-.1.61.61,0,0,0,.12-.34,3.85,3.85,0,0,0,0-.66v-.56a.63.63,0,0,1-.28.23.93.93,0,0,1-.42.09,1,1,0,0,1-.7-.21,1.13,1.13,0,0,1-.37-.59,2.68,2.68,0,0,1-.12-.83,2.86,2.86,0,0,1,.15-1,1.27,1.27,0,0,1,.46-.64,1.52,1.52,0,0,1,.87-.23,1.54,1.54,0,0,1,.84.22,1.31,1.31,0,0,1,.47.61,2.57,2.57,0,0,1,.15.92v2a3.5,3.5,0,0,1-.12,1,1.26,1.26,0,0,1-.44.67A1.46,1.46,0,0,1,336.3,288.1Zm0-2.94a.37.37,0,0,0,.26-.08l.15-.16V284a1.53,1.53,0,0,0,0-.38.56.56,0,0,0-.12-.28.28.28,0,0,0-.25-.11.32.32,0,0,0-.26.11.71.71,0,0,0-.12.33,3.63,3.63,0,0,0,0,.5c0,.19,0,.35,0,.5a.62.62,0,0,0,.11.33A.31.31,0,0,0,336.3,285.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,289l-.08-.35a.7.7,0,0,0,.31-.18.5.5,0,0,0,.14-.4h-.53v-1h1v.87a1.16,1.16,0,0,1-.21.74A.86.86,0,0,1,338.58,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.36,288.12a1.51,1.51,0,0,1-.87-.21,1,1,0,0,1-.42-.59,3.25,3.25,0,0,1-.11-.88h1a3.53,3.53,0,0,0,0,.5.56.56,0,0,0,.14.3.37.37,0,0,0,.29.1.33.33,0,0,0,.28-.15.87.87,0,0,0,.11-.41,5.73,5.73,0,0,0,0-.62,3.89,3.89,0,0,0,0-.51.8.8,0,0,0-.13-.35.35.35,0,0,0-.3-.13.38.38,0,0,0-.3.13.87.87,0,0,0-.18.36H340l.08-3.1h2.51v.9H341l-.07,1.21a.68.68,0,0,1,.28-.18,1.36,1.36,0,0,1,.41-.09,1.08,1.08,0,0,1,.71.16,1.26,1.26,0,0,1,.41.6,3,3,0,0,1,.14,1,4.92,4.92,0,0,1-.06.8,1.56,1.56,0,0,1-.21.64,1.09,1.09,0,0,1-.44.41A1.66,1.66,0,0,1,341.36,288.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.89,288.1a1.47,1.47,0,0,1-.85-.23,1.35,1.35,0,0,1-.48-.64,2.65,2.65,0,0,1-.15-.92v-1.95a3.6,3.6,0,0,1,.12-1,1.25,1.25,0,0,1,.45-.66,1.4,1.4,0,0,1,.9-.25,1.82,1.82,0,0,1,.81.16.94.94,0,0,1,.43.47,1.91,1.91,0,0,1,.14.76V284h-1a1.32,1.32,0,0,0-.07-.51c0-.12-.15-.17-.32-.17a.33.33,0,0,0-.26.1.64.64,0,0,0-.12.34,3.85,3.85,0,0,0,0,.66V285a.56.56,0,0,1,.27-.23,1.43,1.43,0,0,1,.43-.09,1,1,0,0,1,.69.19,1.22,1.22,0,0,1,.38.57,2.88,2.88,0,0,1,.11.81,3.35,3.35,0,0,1-.13,1,1.31,1.31,0,0,1-.46.67A1.41,1.41,0,0,1,344.89,288.1Zm0-.78a.27.27,0,0,0,.25-.11.67.67,0,0,0,.12-.32,3.68,3.68,0,0,0,0-.51c0-.19,0-.35,0-.5a.61.61,0,0,0-.1-.33.42.42,0,0,0-.47-.08.38.38,0,0,0-.15.09.47.47,0,0,0-.09.12v.87a1.58,1.58,0,0,0,0,.38.55.55,0,0,0,.13.29A.33.33,0,0,0,344.9,287.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.07,288l1.15-4.67h-1.49v-.8h2.51v.69L348.09,288Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--conveyor-belt--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.19,
    y: 301.37,
    width: 389.4,
    height: 22.11,
    rx: 10.2,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.29,
    y: 304.88,
    width: 381.21,
    height: 15.1,
    rx: 6.97,
    style: {
      fill: "#7d7d7d",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503.38,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.14,312.35a2.76,2.76,0,1,0-2.76,2.76A2.76,2.76,0,0,0,506.14,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.12,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.89,312.35a2.77,2.77,0,1,0-2.77,2.76A2.77,2.77,0,0,0,466.89,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.87,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.63,312.35a2.77,2.77,0,1,0-2.76,2.76A2.77,2.77,0,0,0,427.63,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.61,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.37,312.35a2.76,2.76,0,1,0-2.76,2.76A2.76,2.76,0,0,0,388.37,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.35,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12,312.35a2.77,2.77,0,1,0-2.77,2.76A2.77,2.77,0,0,0,349.12,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.1,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,312.35a2.77,2.77,0,1,0-2.76,2.76A2.77,2.77,0,0,0,309.86,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.84,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.6,312.35a2.76,2.76,0,1,0-2.76,2.76A2.76,2.76,0,0,0,270.6,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 538.79,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.55,312.35a2.76,2.76,0,1,0-2.76,2.76A2.76,2.76,0,0,0,541.55,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 574.2,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577,312.35a2.77,2.77,0,1,0-2.77,2.76A2.77,2.77,0,0,0,577,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.62,
    cy: 312.35,
    r: 7.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.38,312.35a2.77,2.77,0,1,0-2.76,2.76A2.77,2.77,0,0,0,612.38,312.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 304.99,
    cy: 132.02,
    r: 16.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.99,
    cy: 132.02,
    r: 13.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,142.72v-2a4.19,4.19,0,0,1-3.26-1.4,6.4,6.4,0,0,1-1.17-3.91l3-.51a9.06,9.06,0,0,0,.22,1.77,2.25,2.25,0,0,0,.54,1.06,1.29,1.29,0,0,0,.93.34,1,1,0,0,0,.9-.42,1.94,1.94,0,0,0,.24-1,3.14,3.14,0,0,0-.49-1.81,7.36,7.36,0,0,0-1.37-1.47l-1.8-1.55a13.13,13.13,0,0,1-1.1-1.16,4.9,4.9,0,0,1-.77-1.36,5.15,5.15,0,0,1-.29-1.8,4.16,4.16,0,0,1,1.13-3.1,4.73,4.73,0,0,1,3-1.26v-1.89h1v1.89a3.79,3.79,0,0,1,1.87.52,3,3,0,0,1,1.11,1.14,5.4,5.4,0,0,1,.56,1.5,11.45,11.45,0,0,1,.21,1.58l-3,.45a9,9,0,0,0-.13-1.39,2,2,0,0,0-.38-.94,1,1,0,0,0-.85-.32,1.07,1.07,0,0,0-.9.47,1.7,1.7,0,0,0-.3,1,2.48,2.48,0,0,0,.46,1.57,11.2,11.2,0,0,0,1.06,1.14l1.76,1.53a12,12,0,0,1,1.29,1.37,6.38,6.38,0,0,1,.95,1.64,5.54,5.54,0,0,1,.36,2.07,4.56,4.56,0,0,1-.45,2,3.84,3.84,0,0,1-1.31,1.49,4.34,4.34,0,0,1-2,.68v2Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.14,
    cy: 193.73,
    r: 13.65,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.14,
    cy: 193.73,
    r: 11.06,
    transform: "translate(-49.08 268.97) rotate(-45)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,202.64V201a3.49,3.49,0,0,1-2.71-1.16,5.35,5.35,0,0,1-1-3.26l2.48-.42a7.88,7.88,0,0,0,.19,1.47,1.87,1.87,0,0,0,.45.88,1.08,1.08,0,0,0,.77.29.79.79,0,0,0,.75-.35,1.57,1.57,0,0,0,.2-.81,2.58,2.58,0,0,0-.41-1.51,6.7,6.7,0,0,0-1.14-1.23l-1.49-1.28a9.18,9.18,0,0,1-.92-1,3.81,3.81,0,0,1-.64-1.13,4.21,4.21,0,0,1-.24-1.5,3.45,3.45,0,0,1,.94-2.58,4,4,0,0,1,2.53-1.05v-1.56h.85v1.56a3.19,3.19,0,0,1,1.55.44,2.56,2.56,0,0,1,.93.95,4.66,4.66,0,0,1,.46,1.25,8.88,8.88,0,0,1,.17,1.31l-2.52.37a7.58,7.58,0,0,0-.1-1.15,1.74,1.74,0,0,0-.32-.79.83.83,0,0,0-.7-.26.88.88,0,0,0-.75.39,1.4,1.4,0,0,0-.26.82,2.06,2.06,0,0,0,.39,1.31,8.62,8.62,0,0,0,.88.95l1.46,1.27a9.71,9.71,0,0,1,1.08,1.14,5.49,5.49,0,0,1,.79,1.37,4.59,4.59,0,0,1,.3,1.72,3.82,3.82,0,0,1-.38,1.7,3.1,3.1,0,0,1-1.09,1.24,3.57,3.57,0,0,1-1.68.56v1.66Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.1,
    cy: 172.23,
    r: 20.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.1,
    cy: 172.23,
    r: 16.58,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,185.58v-2.45a5.28,5.28,0,0,1-4.07-1.75,8,8,0,0,1-1.46-4.89l3.73-.63a11.29,11.29,0,0,0,.28,2.21,2.73,2.73,0,0,0,.67,1.32,1.6,1.6,0,0,0,1.16.43,1.17,1.17,0,0,0,1.13-.53,2.39,2.39,0,0,0,.3-1.21,4,4,0,0,0-.62-2.26,9.47,9.47,0,0,0-1.7-1.84L341,172.05a14.17,14.17,0,0,1-1.37-1.45,5.87,5.87,0,0,1-1-1.69,6.36,6.36,0,0,1-.36-2.25,5.2,5.2,0,0,1,1.42-3.87,5.85,5.85,0,0,1,3.79-1.57v-2.35h1.27v2.35a4.86,4.86,0,0,1,2.34.65,3.82,3.82,0,0,1,1.38,1.42,6.61,6.61,0,0,1,.69,1.88,14.09,14.09,0,0,1,.27,2l-3.78.55a12,12,0,0,0-.16-1.73,2.52,2.52,0,0,0-.48-1.17,1.21,1.21,0,0,0-1.05-.4,1.36,1.36,0,0,0-1.13.58,2.19,2.19,0,0,0-.38,1.24,3.07,3.07,0,0,0,.58,2,13.47,13.47,0,0,0,1.32,1.43l2.2,1.9a15.45,15.45,0,0,1,1.61,1.72,8.14,8.14,0,0,1,1.19,2,6.91,6.91,0,0,1,.45,2.58,5.68,5.68,0,0,1-.57,2.55,4.68,4.68,0,0,1-1.64,1.86,5.32,5.32,0,0,1-2.52.85v2.48Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.72,
    y: 109.48,
    width: 64.68,
    height: 32.68,
    transform: "translate(-30.01 149.97) rotate(-32.89)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.83,131.72a2.31,2.31,0,0,1-.92.35l11.78,18.23a2.49,2.49,0,0,1,.71-.7,2.44,2.44,0,0,1,3.37.73,2.23,2.23,0,0,1,.24.49l42.58-27.54a2.42,2.42,0,0,1,.38-3.79,2.5,2.5,0,0,1,1-.36l-11.81-18.25a2.5,2.5,0,0,1-.72.73,2.44,2.44,0,0,1-3.37-.73l-42.47,27.47A2.44,2.44,0,0,1,209.83,131.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.87,120.13A10.49,10.49,0,1,1,233.36,117,10.49,10.49,0,0,1,247.87,120.13Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.25,132.51l-.84-1.29a3.26,3.26,0,0,1-2.73.46,5,5,0,0,1-2.42-2.07L239,128a7.06,7.06,0,0,0,.9,1.07,1.62,1.62,0,0,0,.8.46,1,1,0,0,0,.76-.17.74.74,0,0,0,.41-.65,1.54,1.54,0,0,0-.26-.75,2.44,2.44,0,0,0-1.09-1,5.9,5.9,0,0,0-1.52-.39l-1.83-.25a8.37,8.37,0,0,1-1.22-.3,3.48,3.48,0,0,1-1.08-.56,3.82,3.82,0,0,1-1-1.06,3.21,3.21,0,0,1-.58-2.51,3.74,3.74,0,0,1,1.46-2.12l-.8-1.23.67-.43.8,1.23a3.14,3.14,0,0,1,1.45-.45,2.33,2.33,0,0,1,1.21.28,4,4,0,0,1,1,.75,8.62,8.62,0,0,1,.81.94l-1.8,1.58a7.38,7.38,0,0,0-.67-.86,1.6,1.6,0,0,0-.65-.45.76.76,0,0,0-.69.15.85.85,0,0,0-.39.69,1.29,1.29,0,0,0,.22.78,2,2,0,0,0,1,.83,7,7,0,0,0,1.18.3l1.8.25a9.07,9.07,0,0,1,1.43.36,5.13,5.13,0,0,1,1.32.67,4.31,4.31,0,0,1,1.11,1.2,3.49,3.49,0,0,1,.57,1.54,3,3,0,0,1-.23,1.53,3.28,3.28,0,0,1-1,1.3l.84,1.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.55,
    y: 113.5,
    width: 64.68,
    height: 32.68,
    transform: "translate(-29.42 90.02) rotate(-19.67)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.09,128.9a2.55,2.55,0,0,1-1,.13l7.31,20.44a2.48,2.48,0,0,1,.84-.52,2.45,2.45,0,0,1,3.12,1.48,2.4,2.4,0,0,1,.12.53l47.75-17.07a2.23,2.23,0,0,1-.24-.49,2.43,2.43,0,0,1,1.47-3.12,2.56,2.56,0,0,1,1-.13l-7.32-20.47a2.31,2.31,0,0,1-.87.55,2.43,2.43,0,0,1-3.11-1.48l-47.63,17A2.45,2.45,0,0,1,215.09,128.9Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.89,
    cy: 129.84,
    r: 10.49,
    transform: "translate(20.2 292.15) rotate(-63.78)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,137.3l-.52-1.44a3.29,3.29,0,0,1-2.76-.17,5.06,5.06,0,0,1-1.89-2.58l2.06-1.16a7.07,7.07,0,0,0,.63,1.24,1.69,1.69,0,0,0,.68.64,1,1,0,0,0,.77,0,.73.73,0,0,0,.56-.54,1.66,1.66,0,0,0-.08-.79,2.56,2.56,0,0,0-.84-1.2,6.09,6.09,0,0,0-1.4-.72l-1.73-.66a9.6,9.6,0,0,1-1.11-.57,3.83,3.83,0,0,1-.93-.79,4.1,4.1,0,0,1-.68-1.25,3.24,3.24,0,0,1,0-2.58,3.69,3.69,0,0,1,1.9-1.73l-.49-1.38.74-.27.5,1.39a3,3,0,0,1,1.51-.11,2.4,2.4,0,0,1,1.12.54,4.18,4.18,0,0,1,.8,1,7.21,7.21,0,0,1,.57,1.1l-2.11,1.12a7,7,0,0,0-.46-1,1.57,1.57,0,0,0-.52-.6.8.8,0,0,0-.71,0,.84.84,0,0,0-.54.58,1.32,1.32,0,0,0,0,.81,1.88,1.88,0,0,0,.75,1,7.85,7.85,0,0,0,1.08.57l1.69.66a8.62,8.62,0,0,1,1.32.67,5.38,5.38,0,0,1,1.13,1,4.57,4.57,0,0,1,.81,1.43,3.66,3.66,0,0,1,.2,1.62,2.94,2.94,0,0,1-.58,1.44,3.28,3.28,0,0,1-1.3,1l.52,1.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.74,
    y: 125.08,
    width: 64.68,
    height: 32.68,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,130.5a2.41,2.41,0,0,1-1-.21V152a2.4,2.4,0,0,1,1-.2,2.44,2.44,0,0,1,2.44,2.43,2.35,2.35,0,0,1-.07.54h50.71a2.35,2.35,0,0,1-.06-.54A2.43,2.43,0,0,1,277.8,152V130.28a2.43,2.43,0,0,1-3.44-2.22H223.78A2.44,2.44,0,0,1,221.34,130.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.08,
    cy: 141.42,
    r: 10.49,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,149.31v-1.54a3.31,3.31,0,0,1-2.55-1.09,5.08,5.08,0,0,1-.91-3.06l2.33-.4a6.92,6.92,0,0,0,.18,1.38,1.66,1.66,0,0,0,.42.83,1,1,0,0,0,.73.27.74.74,0,0,0,.7-.33,1.45,1.45,0,0,0,.19-.76,2.49,2.49,0,0,0-.39-1.42,5.59,5.59,0,0,0-1.07-1.14l-1.4-1.21a9.06,9.06,0,0,1-.86-.91,3.56,3.56,0,0,1-.6-1.06,4,4,0,0,1-.23-1.41,3.25,3.25,0,0,1,.89-2.42,3.67,3.67,0,0,1,2.37-1v-1.47h.79v1.47a3.11,3.11,0,0,1,1.47.4,2.49,2.49,0,0,1,.87.9,4.41,4.41,0,0,1,.43,1.17,9.44,9.44,0,0,1,.16,1.23l-2.36.35A10,10,0,0,0,250,137a1.69,1.69,0,0,0-.3-.74.75.75,0,0,0-.66-.25.86.86,0,0,0-.71.37,1.32,1.32,0,0,0-.23.77,2,2,0,0,0,.36,1.23,7.62,7.62,0,0,0,.83.89l1.37,1.19a9.42,9.42,0,0,1,1,1.08,4.92,4.92,0,0,1,.74,1.28,4.25,4.25,0,0,1,.28,1.61,3.68,3.68,0,0,1-.35,1.6,3,3,0,0,1-1,1.16,3.23,3.23,0,0,1-1.58.53v1.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--file-cabinet--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.08,
    y: 197.95,
    width: 112.34,
    height: 240.16,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "702.8 275.07 599.08 294.91 599.08 229.85 608.07 213.12 702.8 275.07",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "702.8 346.42 599.08 366.25 599.08 301.2 608.07 284.46 702.8 346.42",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.08,
    y: 283.86,
    width: 94.72,
    height: 61.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "702.8 416.92 599.08 436.75 599.08 371.7 608.07 354.96 702.8 416.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "672.74 197.06 629.39 197.06 629.39 148 638.1 139.93 672.74 139.93 672.74 197.06",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.39 148 638.18 148 638.18 139.93 629.39 148",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 153.67,
    x2: 667.08,
    y2: 153.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 159.1,
    x2: 667.08,
    y2: 159.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 164.54,
    x2: 667.08,
    y2: 164.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 169.97,
    x2: 667.08,
    y2: 169.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 175.4,
    x2: 667.08,
    y2: 175.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 180.83,
    x2: 667.08,
    y2: 180.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 635.15,
    y1: 186.27,
    x2: 667.08,
    y2: 186.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.41,177.13v-1.44a1.81,1.81,0,0,0-1.8-1.8h-23a1.81,1.81,0,0,0-1.8,1.8v1.42a2.54,2.54,0,0,1-2.54,2.54h-.44v52.19H689V182.12a2.48,2.48,0,0,0-2.47-2.47H646.93A2.52,2.52,0,0,1,644.41,177.13Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.08,
    y: 213.12,
    width: 94.72,
    height: 61.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 237.07,
    width: 23.68,
    height: 14.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 307.81,
    width: 23.68,
    height: 14.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.08,
    y: 354.6,
    width: 94.72,
    height: 61.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 378.55,
    width: 23.68,
    height: 14.05,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calculator--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.91,166.79H106.48a17.26,17.26,0,0,0-16.62,17.36l3,65.09V423.69A14.34,14.34,0,0,0,107.17,438H245.56a15.86,15.86,0,0,0,15.16-15.16V248.41l3-65.09A15.81,15.81,0,0,0,247.91,166.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,246.42l2.74-60.73a9.69,9.69,0,0,0-9.68-10.12H108.3a9.68,9.68,0,0,0-9.68,10.12l2.73,60.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.75,
    y: 191.33,
    width: 140.24,
    height: 47.43,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.68,
    y: 198.26,
    width: 126.4,
    height: 33.59,
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.76,224.66v-2.13a4.51,4.51,0,0,1-3.51-1.5,6.86,6.86,0,0,1-1.26-4.22l3.22-.55a9.31,9.31,0,0,0,.24,1.9,2.44,2.44,0,0,0,.58,1.15,1.37,1.37,0,0,0,1,.37,1,1,0,0,0,1-.45,2.05,2.05,0,0,0,.27-1,3.4,3.4,0,0,0-.54-2,8.46,8.46,0,0,0-1.47-1.58L122.32,213a13.78,13.78,0,0,1-1.19-1.25,5.12,5.12,0,0,1-.83-1.46,5.45,5.45,0,0,1-.31-1.94,4.5,4.5,0,0,1,1.22-3.35,5,5,0,0,1,3.28-1.35v-2h1.09v2a4.23,4.23,0,0,1,2,.55,3.31,3.31,0,0,1,1.2,1.24,5.69,5.69,0,0,1,.59,1.62,11.53,11.53,0,0,1,.23,1.7l-3.26.48a10.51,10.51,0,0,0-.14-1.5,2.19,2.19,0,0,0-.41-1,1.05,1.05,0,0,0-.91-.35,1.17,1.17,0,0,0-1,.51,1.83,1.83,0,0,0-.33,1.07,2.64,2.64,0,0,0,.5,1.69,10.79,10.79,0,0,0,1.14,1.23l1.89,1.64a12.34,12.34,0,0,1,1.4,1.49,7,7,0,0,1,1,1.77,5.87,5.87,0,0,1,.39,2.22,4.84,4.84,0,0,1-.49,2.2,4.08,4.08,0,0,1-1.42,1.61,4.52,4.52,0,0,1-2.17.73v2.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,222.31V218h-5.61v-2.76l4.81-11.41h4.11V215.3h1.78V218h-1.78v4.32Zm-2.83-7h2.83v-7.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,222.63a5.25,5.25,0,0,1-3-.71,3.53,3.53,0,0,1-1.4-2,10.65,10.65,0,0,1-.38-3h3.41a10,10,0,0,0,.12,1.69,1.94,1.94,0,0,0,.46,1,1.26,1.26,0,0,0,1,.32,1.1,1.1,0,0,0,1-.5,3,3,0,0,0,.36-1.37c.05-.6.07-1.3.07-2.1a12.74,12.74,0,0,0-.11-1.74,2.6,2.6,0,0,0-.45-1.18,1.19,1.19,0,0,0-1-.44,1.34,1.34,0,0,0-1,.44,2.72,2.72,0,0,0-.58,1.23h-3l.25-10.5h8.49v3h-5.59l-.21,4.08a2.13,2.13,0,0,1,.93-.59,4.54,4.54,0,0,1,1.4-.3,3.36,3.36,0,0,1,2.38.55,4.06,4.06,0,0,1,1.41,2,10.24,10.24,0,0,1,.45,3.25,18.81,18.81,0,0,1-.18,2.7,5.92,5.92,0,0,1-.71,2.15,3.57,3.57,0,0,1-1.5,1.4A5.58,5.58,0,0,1,148,222.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,225.46l-.27-1.17a2.73,2.73,0,0,0,1.07-.63,1.75,1.75,0,0,0,.48-1.35h-1.8V219H158v2.95a4.14,4.14,0,0,1-.71,2.49A2.94,2.94,0,0,1,155.2,225.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08,222.56a4.86,4.86,0,0,1-2.86-.79,4.44,4.44,0,0,1-1.62-2.16,8.88,8.88,0,0,1-.51-3.12v-6.58a11.57,11.57,0,0,1,.42-3.24,4.32,4.32,0,0,1,1.49-2.26,5,5,0,0,1,3.06-.82,5.86,5.86,0,0,1,2.73.54,3.16,3.16,0,0,1,1.47,1.59,6.46,6.46,0,0,1,.46,2.57.76.76,0,0,0,0,.15.81.81,0,0,1,0,.15h-3.33a5,5,0,0,0-.23-1.73c-.15-.38-.52-.57-1.1-.57a1.07,1.07,0,0,0-.85.34,2.26,2.26,0,0,0-.44,1.15,16,16,0,0,0-.12,2.23v1.89a2,2,0,0,1,.92-.78,3.86,3.86,0,0,1,1.45-.29,3.43,3.43,0,0,1,2.34.65,3.83,3.83,0,0,1,1.27,1.91,9.09,9.09,0,0,1,.39,2.75,11.38,11.38,0,0,1-.46,3.34,4.36,4.36,0,0,1-1.54,2.27A4.84,4.84,0,0,1,165.08,222.56Zm0-2.63a1,1,0,0,0,.86-.39,2.29,2.29,0,0,0,.38-1.09,11.76,11.76,0,0,0,.11-1.71q0-1-.06-1.68a2.29,2.29,0,0,0-.35-1.13,1.15,1.15,0,0,0-1-.41,1.38,1.38,0,0,0-.6.13,1.65,1.65,0,0,0-.81.71v2.95a6.73,6.73,0,0,0,.12,1.29,2.24,2.24,0,0,0,.45,1A1.12,1.12,0,0,0,165.13,219.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,222.31l3.88-15.8h-5.05v-2.69h8.49v2.33l-3.9,16.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,222.63a5.44,5.44,0,0,1-2.94-.7,3.91,3.91,0,0,1-1.56-2,8.22,8.22,0,0,1-.48-2.91v-.66H185V217a8,8,0,0,0,.14,1.47,1.71,1.71,0,0,0,.45.88,1.28,1.28,0,0,0,.91.3,1.22,1.22,0,0,0,.92-.31,1.8,1.8,0,0,0,.41-.9A8.52,8.52,0,0,0,188,217a4.68,4.68,0,0,0-.41-2.16,1.73,1.73,0,0,0-1.64-.79h-.62v-2.6h.55a1.89,1.89,0,0,0,1.68-.66,3.85,3.85,0,0,0,.44-2.08,3.8,3.8,0,0,0-.32-1.71,1.21,1.21,0,0,0-1.19-.61,1.12,1.12,0,0,0-1.14.68,5,5,0,0,0-.29,1.76v.82h-3.52v-1a5.79,5.79,0,0,1,.6-2.75,4,4,0,0,1,1.68-1.73,5.6,5.6,0,0,1,2.67-.59,5.91,5.91,0,0,1,2.7.57,3.92,3.92,0,0,1,1.7,1.67,5.69,5.69,0,0,1,.58,2.71,5.1,5.1,0,0,1-.67,2.7,3,3,0,0,1-1.66,1.36,3.14,3.14,0,0,1,1.21.76,3.61,3.61,0,0,1,.82,1.4,6.83,6.83,0,0,1,.3,2.18,8.47,8.47,0,0,1-.48,3,4.06,4.06,0,0,1-1.57,2A5.21,5.21,0,0,1,186.47,222.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.68,225.46l-.27-1.17a2.73,2.73,0,0,0,1.07-.63,1.75,1.75,0,0,0,.48-1.35h-1.81V219h3.31v2.95a4.14,4.14,0,0,1-.7,2.49A2.94,2.94,0,0,1,193.68,225.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.24,222.56a5.93,5.93,0,0,1-2.74-.54,3.16,3.16,0,0,1-1.48-1.6,6.42,6.42,0,0,1-.46-2.59v-.27h3.33a4.68,4.68,0,0,0,.24,1.73c.16.38.54.57,1.13.57a1.06,1.06,0,0,0,.85-.34,2.28,2.28,0,0,0,.41-1.16,18.28,18.28,0,0,0,.11-2.22v-1.89a2.06,2.06,0,0,1-.93.78,3.7,3.7,0,0,1-1.42.29,3.43,3.43,0,0,1-2.37-.72,4,4,0,0,1-1.27-2,9.76,9.76,0,0,1-.37-2.79,10.33,10.33,0,0,1,.47-3.28,4.26,4.26,0,0,1,1.59-2.17,5,5,0,0,1,2.91-.78,5,5,0,0,1,2.85.74,4.26,4.26,0,0,1,1.6,2.07,8.84,8.84,0,0,1,.5,3.1v6.74a11.58,11.58,0,0,1-.41,3.24,4.21,4.21,0,0,1-1.48,2.26A5,5,0,0,1,203.24,222.56Zm0-9.93a1.23,1.23,0,0,0,.86-.29,2.82,2.82,0,0,0,.51-.55v-2.95a7.5,7.5,0,0,0-.11-1.3,2.22,2.22,0,0,0-.41-1,1.07,1.07,0,0,0-.87-.36,1,1,0,0,0-.87.39,2.39,2.39,0,0,0-.4,1.09,13.58,13.58,0,0,0-.1,1.71,16.63,16.63,0,0,0,.07,1.67,2.4,2.4,0,0,0,.35,1.14A1.11,1.11,0,0,0,203.26,212.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.34,222.58a5.27,5.27,0,0,1-2.93-.72,3.91,3.91,0,0,1-1.56-2,8.77,8.77,0,0,1-.47-3,7,7,0,0,1,.14-1.41,5.07,5.07,0,0,1,.41-1.21,4.18,4.18,0,0,1,.67-1,3.71,3.71,0,0,1,1-.7,4.59,4.59,0,0,1-1.31-1.54,5.21,5.21,0,0,1-.58-2.52,5.78,5.78,0,0,1,.5-2.63,3.7,3.7,0,0,1,1.57-1.7,6,6,0,0,1,5.22,0,3.64,3.64,0,0,1,1.54,1.7,6.21,6.21,0,0,1,.48,2.63,5.56,5.56,0,0,1-.56,2.55,4.26,4.26,0,0,1-1.31,1.51,3.49,3.49,0,0,1,.94.7,4.22,4.22,0,0,1,.68,1,5.57,5.57,0,0,1,.42,1.21,6.35,6.35,0,0,1,.15,1.41,7.7,7.7,0,0,1-.45,3,4,4,0,0,1-1.57,2A5.23,5.23,0,0,1,215.34,222.58Zm0-2.62a1.14,1.14,0,0,0,1-.46,2.59,2.59,0,0,0,.41-1.12,9.51,9.51,0,0,0,.09-1.28,8.16,8.16,0,0,0-.08-1.41,2.52,2.52,0,0,0-.42-1.12,1.32,1.32,0,0,0-1.95,0,2.42,2.42,0,0,0-.44,1.11,9.22,9.22,0,0,0-.1,1.42,9.77,9.77,0,0,0,.09,1.29,2.39,2.39,0,0,0,.42,1.12A1.15,1.15,0,0,0,215.34,220Zm0-8.7a.91.91,0,0,0,.74-.34,2.28,2.28,0,0,0,.42-1,7.39,7.39,0,0,0,.14-1.51,3.63,3.63,0,0,0-.31-1.59,1,1,0,0,0-1-.6,1.09,1.09,0,0,0-1,.6,3.29,3.29,0,0,0-.33,1.57,8.52,8.52,0,0,0,.12,1.52,2.07,2.07,0,0,0,.44,1A1,1,0,0,0,215.34,211.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.43,222.63a5.09,5.09,0,0,1-2.76-.69,4.22,4.22,0,0,1-1.64-1.88,6.52,6.52,0,0,1-.55-2.77V209a7.13,7.13,0,0,1,.52-2.84,4.15,4.15,0,0,1,1.62-1.91,5.29,5.29,0,0,1,2.81-.68,5.14,5.14,0,0,1,2.77.68,4.13,4.13,0,0,1,1.61,1.91,7.12,7.12,0,0,1,.53,2.84v8.29a6.68,6.68,0,0,1-.55,2.77,4.29,4.29,0,0,1-1.64,1.88A5,5,0,0,1,227.43,222.63Zm0-3.11a1,1,0,0,0,.89-.39,2.31,2.31,0,0,0,.37-.92,6.06,6.06,0,0,0,.09-1v-8.15a7.9,7.9,0,0,0-.08-1,2.22,2.22,0,0,0-.36-1,1,1,0,0,0-.91-.4,1.06,1.06,0,0,0-.92.4,2.11,2.11,0,0,0-.37,1,7.9,7.9,0,0,0-.08,1v8.15a6.06,6.06,0,0,0,.09,1,2,2,0,0,0,.39.92A1.06,1.06,0,0,0,227.43,219.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.01,
    y: 265.69,
    width: 70.76,
    height: 20.77,
    rx: 4.04,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.88,
    y1: 265.94,
    x2: 121.88,
    y2: 286.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.15,
    y1: 265.94,
    x2: 136.15,
    y2: 286.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.42,
    y1: 265.94,
    x2: 150.42,
    y2: 286.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.69,
    y1: 265.94,
    x2: 164.69,
    y2: 286.45,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.76,
    y: 277.1,
    width: 25.18,
    height: 16.3,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.44,
    y: 299.59,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.95,
    y: 299.59,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 299.59,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 299.59,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 299.59,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.44,
    y: 325.39,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.95,
    y: 325.39,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 325.39,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 325.39,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 325.39,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.44,
    y: 351.19,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.95,
    y: 351.19,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 351.19,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 351.19,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 351.19,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.44,
    y: 376.98,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.95,
    y: 376.98,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 376.98,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 376.98,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.44,
    y: 402.78,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.95,
    y: 402.78,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.46,
    y: 402.78,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.97,
    y: 402.78,
    width: 25.18,
    height: 19.19,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,377H229.29a3.82,3.82,0,0,0-3.81,3.82v37.35a3.82,3.82,0,0,0,3.81,3.82h17.55a3.82,3.82,0,0,0,3.81-3.82V380.8A3.82,3.82,0,0,0,246.84,377Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.48,
    y: 277.1,
    width: 25.18,
    height: 16.3,
    rx: 3.76,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.97 340.55 66.99 435.83 59.88 435.83 55.8 359.04 53.8 359.04 46.22 435.83 39.68 435.83 37.97 339.98 70.97 340.55",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.39,
    y: 280.18,
    width: 26.74,
    height: 60.37,
    transform: "translate(109.51 620.73) rotate(180)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.17 278.38 61.86 378.5 75.83 378.5 75.83 280.21 61.17 278.38",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.4 311.83 61.17 278.38 63.9 278.72 66.9 288.92 63.01 292.36 66.67 296.48 61.4 311.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.83,280.21,94.16,313s.23,3.67-2.52,5-4.81,1.15-5.5.69-11-7.79-11-7.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.4 274.94 61.4 281.13 57.74 287.09 51.78 280.21 51.78 272.88 61.4 274.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.73,251.69h1.33A7.93,7.93,0,0,1,66,259.62v11.27a6.24,6.24,0,0,1-6.24,6.24H55a6.24,6.24,0,0,1-6.24-6.24V259.62a7.93,7.93,0,0,1,7.93-7.93Z",
    transform: "translate(114.78 528.81) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,251.69c-2,.34-4.11,2.8-3.33,3.93l1.91,3L50.7,260v12.22s6.95-2.36,9.76-2.47a7.92,7.92,0,0,1,5.07,2.06,7.91,7.91,0,0,1-7.47,5.32H56.73a7.93,7.93,0,0,1-7.93-7.93V257.93A6.24,6.24,0,0,1,55,251.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75,251.69h4a6.16,6.16,0,0,1,1.55.2c-.14.68-.57,2.24-1.63,2.16S57.35,252,55.75,251.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,272.32s-1.35.67-4-.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "61.35 263.64 61.35 270.98 58.98 269.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.74,261.44a2,2,0,0,0-2.79,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.81,261.61a3,3,0,0,0-3.89,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,263.94c0,.72.27,1.31.59,1.31s.6-.59.6-1.31-.27-1.32-.6-1.32S63,263.21,63,263.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.95,
    cy: 263.94,
    rx: 0.59,
    ry: 1.31,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8,262.92s-1.15-3.21-2.29-.92a6.74,6.74,0,0,0,.46,6.41,1.13,1.13,0,0,0,1.83.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78,278.84,51.09,378H30.24s2.06-49,2.06-49.72,2.3-7.1,2.3-7.1L33.68,280Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.72 292.36 44.91 289.61 47.88 279.08 51.78 278.84 51.55 312.07 45.13 296.25 49.72 292.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.44,311.6l-.68,6.64-32.08,3.44s-1.6-2.29,0-7.56,11-34.14,11-34.14l.77,27.21-1.92,3.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.92 298.08 76.52 321.91 57.05 321.91 65.98 297.62 85.92 298.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.44 311.6 59.19 309.41 61.81 308.75 61.28 310.45 67.84 313.86 66.92 315.57 61.81 316.75 58.92 316.88 55.25 316.22 55.44 311.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.36 297.9 78.07 300 71.53 300 72.43 297.81 79.36 297.9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.08 433.04 78.22 438.11 59.31 438.11 59.94 432.85 67.08 433.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.89 433.04 58.03 438.11 39.11 438.11 39.74 432.85 46.89 433.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glasses--inject-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "419.44 42.27 419.44 149.47 436.96 149.47 436.96 42.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.27,
    y: 106.35,
    width: 33.85,
    height: 16.12,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.83,
    y: 129.23,
    width: 22.59,
    height: 51.06,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.25,
    y: 180.3,
    width: 13.75,
    height: 22.59,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.14,328.09a65.31,65.31,0,1,0-65.3-65.31A65.31,65.31,0,0,0,428.14,328.09Zm0-122.75a57.45,57.45,0,1,1-57.45,57.44A57.45,57.45,0,0,1,428.14,205.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.27,115.46H483a7.07,7.07,0,0,1,7.07,7.07v0a8.29,8.29,0,0,1-8.29,8.29H374.5a8.29,8.29,0,0,1-8.29-8.29v0a7.07,7.07,0,0,1,7.07-7.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.25 117.94 456.08 125.36 482.25 149.33 489.42 141.9 463.25 117.94",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486.41,
    y: 144.04,
    width: 6.28,
    height: 10.32,
    transform: "translate(42.21 397.8) rotate(-46.01)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.11,192.84a29.84,29.84,0,1,0-42.19.75A29.83,29.83,0,0,0,534.11,192.84Zm-40.36-39a26.25,26.25,0,1,1,.66,37.12A26.26,26.26,0,0,1,493.75,153.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.61 117.94 400.77 125.36 374.6 149.33 367.44 141.9 393.61 117.94",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.17,
    y: 144.04,
    width: 6.28,
    height: 10.32,
    transform: "translate(515.06 517.09) rotate(-133.99)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,192.84a29.84,29.84,0,1,1,42.2.75A29.84,29.84,0,0,1,322.74,192.84Zm40.36-39a26.25,26.25,0,1,0-.66,37.12A26.24,26.24,0,0,0,363.1,153.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 558.47,
    y1: 438.6,
    x2: 733.07,
    y2: 438.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.74,
    y1: 438.6,
    x2: 548.45,
    y2: 438.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuiltWallet);
export default __webpack_public_path__ + "static/media/builtWallet.70378d095d095649e12a5019d912d1a3.svg";
export { ForwardRef as ReactComponent };